/** "1 item", "2 items": the number written out with the singular for one and the plural for anything else (including zero). `many` is the singular and an "s" unless given. */
export const plural = (n: number, one: string, many = `${one}s`): string => `${n} ${n === 1 ? one : many}`;
